<template>
    <div class="flex float-left vertical-center">
        <vs-chip class="line-0" v-bind:color="statusColor">
            <vs-avatar style="background: hsla(0, 0%, 100%, .2)" v-bind:icon="statusIcon"/>
            {{statusText}}
        </vs-chip>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "StatusTableAgGridComponent",
        data() {
            return {
                statusIcon: '',
                statusColor: '',
                statusText: ''
            }
        },
        mounted() {
            if (this.params.value !== null && this.params.value !== undefined) {
                if (this.params.value === 'pending') {
                    this.statusColor = 'warning'
                    this.statusText = 'Waiting for verified'
                    this.statusIcon = 'hourglass_full'
                } else if (this.params.value === 'reject') {
                    this.statusColor = 'danger'
                    this.statusText = 'Rejected'
                    this.statusIcon = 'close'
                } else if (this.params.value === 'inactive'){
                    this.statusColor = 'dark'
                    this.statusText = 'Inactive'
                    this.statusIcon = 'domain_disabled'
                }  else {
                    this.statusColor = 'success'
                    this.statusText = 'Verified'
                    this.statusIcon = 'verified_user'
                }
            } else {
                this.statusColor = 'dark'
                this.statusText = 'Active Pending'
                this.statusIcon = 'lock'
            }
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .line-0 {
        line-height: 0;
    }
</style>